import RegistrationOverlayTracker from './overlay';


export const registrationOverlayTracker = new RegistrationOverlayTracker();
